import React, { Component } from "react";
import { Form, Button, Col, Row, Icon, Tooltip, Drawer, Modal, message, Divider, TimePicker } from "antd";
import axios from "axios";
import Colors from '../utils/Colors';
import InputForm from "./InputForm";
import { getUsuario, saveToken, savePermissoes } from "../utils/LoginManager";
import moment from "moment-timezone";
import MunicipioFrame from './MunicipioFrame';


const { Item: ItemForm } = Form;

export const OPCOES_COMBO_ORIGEM = [
    { key: '0', label: '0 - NACIONAL, EXCETO AS INDICADAS NOS CÓDIGOS 3 A 5' },
    { key: '1', label: '1 - ESTRANGEIRA - IMPORTAÇÃO DIRETA, EXCETO A INDICADA NO CÓDIGO 6' },
    { key: '2', label: '2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CÓDIGO 7' },
    { key: '3', label: '3 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO SUPERIOR A 40% (QUARENTA POR CENTO)' },
    { key: '4', label: '4 - NACIONAL, CUJA PRODUÇÃO TENHA SIDO FEITA EM CONFORMIDADE COM OS PROCESSOS PRODUTIVOS BÁSICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67, E AS LEIS NºS 8.248/91, 8.387/91, 10.176/01 E 11.484/ 07' },
    { key: '5', label: '5 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)' },
    { key: '6', label: '6 - ESTRANGEIRA - IMPORTAÇÃO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUÇÃO CAMEX' },
    { key: '7', label: '7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUÇÃO CAMEX' },
    { key: '8', label: '8 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO SUPERIOR A 70%' },
]

export const OPCOES_COMBO_CST_ICMS = [
    { key: '101', label: '101 - Tributada pelo Simples Nacional com permissão de crédito' },
    { key: '102', label: '102 - Tributada pelo Simples Nacional sem permissão de crédito' },
    { key: '103', label: '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta' },
    { key: '201', label: '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária' },
    { key: '202', label: '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária' },
    { key: '203', label: '203 - Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária' },
    { key: '300', label: '300 - Imune' },
    { key: '400', label: '400 - Não tributada pelo Simples Nacional' },
    { key: '500', label: '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação' },
    { key: '900', label: '900 - Outros' },
]

export const OPCOES_COMBO_CST_IPI = [
    { key: '00', label: '00 - ENTRADA COM RECUPERAÇÃO DE CRÉDITO' },
    { key: '01', label: '01 - ENTRADA TRIBUTADA COM ALÍQUOTA ZERO' },
    { key: '02', label: '02 - ENTRADA ISENTA' },
    { key: '03', label: '03 - ENTRADA NÃO-TRIBUTADA' },
    { key: '04', label: '04 - ENTRADA IMUNE' },
    { key: '05', label: '05 - ENTRADA COM SUSPENSÃO' },
    { key: '49', label: '49 - OUTRAS ENTRADAS' },
    { key: '50', label: '50 - SAÍDA TRIBUTADA' },
    { key: '51', label: '51 - SAÍDA TRIBUTADA COM ALÍQUOTA ZERO' },
    { key: '52', label: '52 - SAÍDA ISENTA' },
    { key: '53', label: '53 - SAÍDA NÃO-TRIBUTADA' },
    { key: '54', label: '54 - SAÍDA IMUNE' },
    { key: '55', label: '55 - SAÍDA COM SUSPENSÃO' },
    { key: '99', label: '99 - OUTRAS SAÍDAS' },
]

export const OPCOES_COMBO_CST_PIS = [
    { key: '01', label: '01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
    { key: '02', label: '02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA DIFERENCIADA' },
    { key: '03', label: '03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE DE MEDIDA DE PRODUTO' },
    { key: '04', label: '04 - OPERAÇÃO TRIBUTÁVEL MONOFÁSICA - REVENDA A ALÍQUOTA ZERO' },
    { key: '05', label: '05 - OPERAÇÃO TRIBUTÁVEL POR SUBSTITUIÇÃO TRIBUTÁRIA' },
    { key: '06', label: '06 - OPERAÇÃO TRIBUTÁVEL A ALÍQUOTA ZERO' },
    { key: '07', label: '07 - OPERAÇÃO ISENTA DA CONTRIBUIÇÃO' },
    { key: '08', label: '08 - OPERAÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
    { key: '09', label: '09 - OPERAÇÃO COM SUSPENSÃO DA CONTRIBUIÇÃO' },
    { key: '09', label: '09 - OUTRAS OPERAÇÕES DE SAÍDA' },
    { key: '50', label: '50 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
    { key: '51', label: '51 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA NÃO TRIBUTADA NO MERCADO INTERNO' },
    { key: '52', label: '52 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
    { key: '53', label: '53 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
    { key: '54', label: '54 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '55', label: '55 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '56', label: '56 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
    { key: '60', label: '60 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
    { key: '61', label: '61 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA NÃO-TRIBUTADA NO MERCADO INTERNO' },
    { key: '62', label: '62 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
    { key: '63', label: '63 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
    { key: '64', label: '64 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '65', label: '65 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '66', label: '66 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
    { key: '67', label: '67 - CRÉDITO PRESUMIDO - OUTRAS OPERAÇÕES' },
    { key: '70', label: '70 - OPERAÇÃO DE AQUISIÇÃO SEM DIREITO A CRÉDITO' },
    { key: '71', label: '71 - OPERAÇÃO DE AQUISIÇÃO COM ISENÇÃO' },
    { key: '72', label: '72 - OPERAÇÃO DE AQUISIÇÃO COM SUSPENSÃO' },
    { key: '73', label: '73 - OPERAÇÃO DE AQUISIÇÃO A ALÍQUOTA ZERO' },
    { key: '74', label: '74 - OPERAÇÃO DE AQUISIÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
    { key: '75', label: '75 - OPERAÇÃO DE AQUISIÇÃO POR SUBSTITUIÇÃO TRIBUTÁRIA' },
    { key: '98', label: '98 - OUTRAS OPERAÇÕES DE ENTRADA' },
    { key: '99', label: '99 - OUTRAS OPERAÇÕES' },
]

export const OPCOES_COMBO_CST_COFINS = [
    { key: '01', label: '01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
    { key: '02', label: '02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA DIFERENCIADA' },
    { key: '03', label: '03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE DE MEDIDA DE PRODUTO' },
    { key: '04', label: '04 - OPERAÇÃO TRIBUTÁVEL MONOFÁSICA - REVENDA A ALÍQUOTA ZERO' },
    { key: '05', label: '05 - OPERAÇÃO TRIBUTÁVEL POR SUBSTITUIÇÃO TRIBUTÁRIA' },
    { key: '06', label: '06 - OPERAÇÃO TRIBUTÁVEL A ALÍQUOTA ZERO' },
    { key: '07', label: '07 - OPERAÇÃO ISENTA DA CONTRIBUIÇÃO' },
    { key: '08', label: '08 - OPERAÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
    { key: '09', label: '09 - OPERAÇÃO COM SUSPENSÃO DA CONTRIBUIÇÃO' },
    { key: '49', label: '49 - OUTRAS OPERAÇÕES DE SAÍDA' },
    { key: '50', label: '50 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
    { key: '51', label: '51 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA NÃO TRIBUTADA NO MERCADO INTERNO' },
    { key: '52', label: '52 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
    { key: '53', label: '53 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
    { key: '54', label: '54 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '55', label: '55 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '56', label: '56 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
    { key: '60', label: '60 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
    { key: '61', label: '61 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA NÃO-TRIBUTADA NO MERCADO INTERNO' },
    { key: '62', label: '62 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
    { key: '63', label: '63 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
    { key: '64', label: '64 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '65', label: '65 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
    { key: '66', label: '66 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
    { key: '67', label: '67 - CRÉDITO PRESUMIDO - OUTRAS OPERAÇÕES' },
    { key: '70', label: '70 - OPERAÇÃO DE AQUISIÇÃO SEM DIREITO A CRÉDITO' },
    { key: '71', label: '71 - OPERAÇÃO DE AQUISIÇÃO COM ISENÇÃO' },
    { key: '72', label: '72 - OPERAÇÃO DE AQUISIÇÃO COM SUSPENSÃO' },
    { key: '73', label: '73 - OPERAÇÃO DE AQUISIÇÃO A ALÍQUOTA ZERO' },
    { key: '74', label: '74 - OPERAÇÃO DE AQUISIÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
    { key: '75', label: '75 - OPERAÇÃO DE AQUISIÇÃO POR SUBSTITUIÇÃO TRIBUTÁRIA' },
    { key: '98', label: '98 - OUTRAS OPERAÇÕES DE ENTRADA' },
    { key: '99', label: '99 - OUTRAS OPERAÇÕES' },
]

export const OPCOES_COMBO_CST_IBS_CBS = [
    { key: '000', label: '000 - TRIBUTAÇÃO INTEGRAL' },
    { key: '010', label: '010 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES – OPERAÇÕES SETOR FINANCEIRO (INSERIDO)' },
    { key: '011', label: '011 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES REDUZIDAS EM 30% e 60% (INSERIDO)' },
    { key: '200', label: '200 - ALÍQUOTA ZERO OU REDUZIDA' },
    { key: '210', label: '210 - ALÍQUOTA REDUZIDA EM 50% E 70% COM REDUTOR DE BASE DE CÁLCULO' },
    { key: '220', label: '220 - ALÍQUOTA FIXA' },
    { key: '221', label: '221 - ALÍQUOTA FIXA PROPORCIONAL' },
    { key: '222', label: '222 - REDUÇÃO DE BASE DE CÁLCULO' },
    { key: '400', label: '400 - ISENÇÃO' },
    { key: '410', label: '410 - IMUNIDADE E NÃO INCIDÊNCIA' },
    { key: '510', label: '510 - DIFERIMENTO' },
    { key: '550', label: '550 - SUSPENSÃO' },
    { key: '620', label: '620 - TRIBUTAÇÃO MONOFÁSICA' },
    { key: '800', label: '800 - TRANSFERÊNCIA DE CRÉDITO' },
    { key: '810', label: '810 - AJUSTES' },
    { key: '820', label: '820 - TRIBUTAÇÃO EM DECLARAÇÃO DE REGIME ESPECÍFICO' },
    { key: '830', label: '830 - Exclusão de base de cálculo' },
]



class ParametrosNFeForm extends Component {
    state = {
        salvando: false,
        OPCOES_COMBO_TIPO_MOV_NF: [],
        OPCOES_COMBO_CFOP: [],

        registro: {
            pnfet_cfop: { key: '0' },
            pnfet_tipo_mov_nf: { key: '0' },
            pnfet_origem_produto: { key: '0' },
            pnfet_municipio: {
                key: '0',
                label: '',
                cmun_uf: '0',
                cuf_sigla: '',
            },
            pnfet_cst_icms: { key: '0' },
            pnfet_picms: 0,
            pnfet_cst_ipi: { key: '0' },
            pnfet_pipi: 0,
            pnfet_cst_pis: { key: '0' },
            pnfet_ppis: 0,
            pnfet_cst_cofins: { key: '0' },
            pnfet_pcofins: 0,
            pnfet_cst_iss: { key: '0' },
            pnfet_piss: 0,

            pnfet_cst_ibs_cbs: { key: '0' },
            pnfet_sit_trib_ibs_cbs: '',
            pnfet_pibs_mun: 0,
            pnfet_pibs_est: 0,
            pnfet_pcbs: 0,
        },
    }


    componentDidMount() {
        const usuario = getUsuario();
        this.setState({
            usuario,
        });
        this.onBuscaParametros();
        this.onBuscaTipoMovNF();
        this.onBuscaNatOper();
    }



    onSalvarClick = () => {
        this.setState({ salvando: true })

        const reg = {
            pnfet_cfop: this.state.registro.pnfet_cfop.key ? String(this.state.registro.pnfet_cfop.key) : '',
            pnfet_tipo_mov_nf: this.state.registro.pnfet_tipo_mov_nf.key ? String(this.state.registro.pnfet_tipo_mov_nf.key) : '',
            pnfet_origem_produto: this.state.registro.pnfet_origem_produto.key ? String(this.state.registro.pnfet_origem_produto.key) : '',
            pnfet_municipio: this.state.registro.pnfet_municipio.key ? String(this.state.registro.pnfet_municipio.key) : '',
            pnfet_cst_icms: this.state.registro.pnfet_cst_icms.key ? String(this.state.registro.pnfet_cst_icms.key) : '',
            pnfet_picms: this.state.registro.pnfet_picms ? this.state.registro.pnfet_picms : 0,
            pnfet_cst_ipi: this.state.registro.pnfet_cst_ipi.key ? String(this.state.registro.pnfet_cst_ipi.key) : '',
            pnfet_pipi: this.state.registro.pnfet_pipi ? this.state.registro.pnfet_pipi : 0,
            pnfet_cst_pis: this.state.registro.pnfet_cst_pis.key ? String(this.state.registro.pnfet_cst_pis.key) : '',
            pnfet_ppis: this.state.registro.pnfet_ppis ? this.state.registro.pnfet_ppis : 0,
            pnfet_cst_cofins: this.state.registro.pnfet_cst_cofins.key ? String(this.state.registro.pnfet_cst_cofins.key) : '',
            pnfet_pcofins: this.state.registro.pnfet_pcofins ? this.state.registro.pnfet_pcofins : 0,

            pnfet_cst_ibs_cbs: this.state.registro.pnfet_cst_ibs_cbs.key ? String(this.state.registro.pnfet_cst_ibs_cbs.key) : '',
            pnfet_sit_trib_ibs_cbs: this.state.registro.pnfet_sit_trib_ibs_cbs ? this.state.registro.pnfet_sit_trib_ibs_cbs : '',
            pnfet_pibs_mun: this.state.registro.pnfet_pibs_mun ? this.state.registro.pnfet_pibs_mun : 0,
            pnfet_pibs_est: this.state.registro.pnfet_pibs_est ? this.state.registro.pnfet_pibs_est : 0,
            pnfet_pcbs: this.state.registro.pnfet_pcbs ? this.state.registro.pnfet_pcbs : 0,
        };

        axios.put('/parametros/updateNFe', reg)
            .then(response => {
                this.setState({ salvando: false })
                message.success('Configurações gravada com sucesso.');
            })
            .catch(error => {
                console.error(error.response);
                this.setState({ salvando: false })
                Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            })

    }


    onBuscaParametros = registro => {
        this.setState({ carregando: true });
        axios.get(`/parametros/parametros_nfe_tributacao`)
            .then(response => {
                const { data } = response;

                data.pnfet_municipio = {
                    key: data.pnfet_municipio ? String(data.pnfet_municipio) : '0',
                    label: data.cmun_descricao ? data.cmun_descricao : '',
                    cmun_uf: data.cmun_uf ? String(data.cmun_uf) : '',
                    cuf_sigla: data.cuf_sigla ? data.cuf_sigla : '',
                };

                data.pnfet_cfop = { key: data.pnfet_cfop ? String(data.pnfet_cfop) : '' };
                data.pnfet_tipo_mov_nf = { key: data.pnfet_tipo_mov_nf ? String(data.pnfet_tipo_mov_nf) : '' };
                data.pnfet_origem_produto = { key: data.pnfet_origem_produto ? String(data.pnfet_origem_produto) : '' };
                data.pnfet_cst_icms = { key: data.pnfet_cst_icms ? String(data.pnfet_cst_icms).padStart(3, '0') : '' };
                data.pnfet_cst_ipi = { key: data.pnfet_cst_ipi ? String(data.pnfet_cst_ipi).padStart(2, '0') : '' };
                data.pnfet_cst_pis = { key: data.pnfet_cst_pis ? String(data.pnfet_cst_pis).padStart(2, '0') : '' };
                data.pnfet_cst_cofins = { key: data.pnfet_cst_cofins ? String(data.pnfet_cst_cofins).padStart(2, '0') : '' };
                data.pnfet_cst_ibs_cbs = { key: data.pnfet_cst_ibs_cbs ? String(data.pnfet_cst_ibs_cbs).padStart(2, '0') : '' };

                this.setState({
                    registro: data,
                    carregando: false,
                })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                })
            })
    };




    onBuscaTipoMovNF = async () => {
        this.setState({ OPCOES_COMBO_TIPO_MOV_NF: [] })
        axios.get('/tipoMovNF/lista')
            .then(response => {
                const { data } = response;
                const OPCOES_COMBO_TIPO_MOV_NF = data.map(regList => {
                    return {
                        key: String(regList.tmnf_idf),
                        label: regList.tmnf_descricao,
                    }
                });
                this.setState({
                    OPCOES_COMBO_TIPO_MOV_NF,
                })
            }).catch(error => {
                console.error(error.response);
            })
    };

    onBuscaNatOper = async () => {
        this.setState({ OPCOES_COMBO_CFOP: [] })
        axios.get('/cfop/lista')
            .then(response => {
                const { data } = response;
                const OPCOES_COMBO_CFOP = data.map(regList => {
                    return {
                        key: String(regList.cfop_codigo),
                        label: String(regList.cfop_codigo) + ' - ' + regList.cfop_descricao,
                    }
                });
                this.setState({
                    OPCOES_COMBO_CFOP,
                })
            }).catch(error => {
                console.error(error.response);
            })
    };


    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        const { registro } = this.state;
        registro[id] = value;
        this.setState({ [id]: value });
    };

    onChangeMunicipio = event => {
        const { registro } = this.state;
        registro['pnfet_municipio'] = event.pnfet_municipio;
        this.setState(event);
    }





    render() {
        const { salvando, OPCOES_COMBO_CFOP, OPCOES_COMBO_TIPO_MOV_NF } = this.state;
        const { pnfet_cfop, pnfet_tipo_mov_nf, nficms_origem, pnfet_municipio,
            pnfet_cst_icms, pnfet_picms, pnfet_cst_ipi, pnfet_pipi, pnfet_cst_pis, pnfet_ppis, pnfet_cst_cofins, pnfet_pcofins, pnfet_cst_iss, pnfet_piss,
            pnfet_cst_ibs_cbs, pnfet_sit_trib_ibs_cbs, pnfet_pibs_mun, pnfet_pibs_est, pnfet_pcbs
        } = this.state.registro;

        // console.log('ParametrosNFeForm.state: ', this.state);

        return (
            <div>
                <span className="tituloPage">Parâmetros Tributação NFe</span>
                <div className="divider-page1" />

                <div style={{ marginTop: 30 }}>
                    <Row>
                        <Col xs={24} md={6} style={{ marginTop: -15, paddingRight: 20 }}>
                            <span>CFOP</span>
                            <InputForm
                                type="select"
                                id="pnfet_cfop"
                                ref="pnfet_cfop"
                                value={pnfet_cfop}
                                placeholder="Selecione o CFOP"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_CFOP}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                                showSearch
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15, paddingRight: 20 }}>
                            <span>Tipo Nota Fiscal</span>
                            <InputForm
                                type="select"
                                id="pnfet_tipo_mov_nf"
                                ref="pnfet_tipo_mov_nf"
                                value={pnfet_tipo_mov_nf}
                                placeholder="Selecione o Tipo"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_TIPO_MOV_NF}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15, paddingRight: 20 }}>
                            <span>Origem</span>
                            <InputForm
                                type="select"
                                id="nficms_origem"
                                ref="nficms_origem"
                                value={nficms_origem}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_ORIGEM}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }}>
                            <MunicipioFrame
                                label="Município"
                                id="pnfet_municipio"
                                value={pnfet_municipio}
                                width={"100%"}
                                onChange={this.onChangeMunicipio}
                                descricaoPrimeiroItem="Todos os Municípios"
                            />
                        </Col>


                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }} >
                            <span>CST ICMS</span>
                            <InputForm
                                type="select"
                                id="pnfet_cst_icms"
                                ref="pnfet_cst_icms"
                                value={pnfet_cst_icms}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_CST_ICMS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }}>
                            <span>Alíquita ICMS</span>
                            <InputForm
                                type="number"
                                id="pnfet_picms"
                                ref="pnfet_picms"
                                value={pnfet_picms}
                                onChange={this.onChange}
                            />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }} >
                            <span>CST IPI</span>
                            <InputForm
                                type="select"
                                id="pnfet_cst_ipi"
                                ref="pnfet_cst_ipi"
                                value={pnfet_cst_ipi}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_CST_IPI}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginTop: -10 }}>
                            <span>Alíquita IPI</span>
                            <InputForm
                                type="number"
                                id="pnfet_pipi"
                                ref="pnfet_pipi"
                                value={pnfet_pipi}
                                onChange={this.onChange}
                            />
                        </Col>


                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }} >
                            <span>CST PIS</span>
                            <InputForm
                                type="select"
                                id="pnfet_cst_pis"
                                ref="pnfet_cst_pis"
                                value={pnfet_cst_pis}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_CST_PIS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }}>
                            <span>Alíquita PIS</span>
                            <InputForm
                                type="number"
                                id="pnfet_ppis"
                                ref="pnfet_ppis"
                                value={pnfet_ppis}
                                onChange={this.onChange}
                            />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }} >
                            <span>CST COFINS</span>
                            <InputForm
                                type="select"
                                id="pnfet_cst_cofins"
                                ref="pnfet_cst_cofins"
                                value={pnfet_cst_cofins}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_CST_COFINS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginTop: -10 }}>
                            <span>Alíquita COFINS</span>
                            <InputForm
                                type="number"
                                id="pnfet_pcofins"
                                ref="pnfet_pcofins"
                                value={pnfet_pcofins}
                                onChange={this.onChange}
                            />
                        </Col>




                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }} >
                            <span>CST IBS/CBS</span>
                            <InputForm
                                type="select"
                                id="pnfet_cst_ibs_cbs"
                                ref="pnfet_cst_ibs_cbs"
                                value={pnfet_cst_ibs_cbs}
                                placeholder="Selecione"
                                onChange={this.onChange}
                                data={OPCOES_COMBO_CST_IBS_CBS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginTop: -10, paddingRight: 20 }} >
                            <span>Situação Tributária</span>
                            <InputForm
                                id="pnfet_sit_trib_ibs_cbs"
                                ref="pnfet_sit_trib_ibs_cbs"
                                maxLength={9}
                                onChange={this.onChange}
                                value={pnfet_sit_trib_ibs_cbs}
                            />
                        </Col>
                        <Col xs={24} sm={4} style={{ marginTop: -10, paddingRight: 20 }}>
                            <span>Alíquita IBS Mun.</span>
                            <InputForm
                                type="number"
                                id="pnfet_pibs_mun"
                                ref="pnfet_pibs_mun"
                                value={pnfet_pibs_mun}
                                onChange={this.onChange}
                            />
                        </Col>
                        <Col xs={24} sm={4} style={{ marginTop: -10, paddingRight: 20 }}>
                            <span>Alíquita IBS Est.</span>
                            <InputForm
                                type="number"
                                id="pnfet_pibs_est"
                                ref="pnfet_pibs_est"
                                value={pnfet_pibs_est}
                                onChange={this.onChange}
                            />
                        </Col>
                        <Col xs={24} sm={4} style={{ marginTop: -10 }}>
                            <span>Alíquita CBS</span>
                            <InputForm
                                type="number"
                                id="pnfet_pcbs"
                                ref="pnfet_pcbs"
                                value={pnfet_pcbs}
                                onChange={this.onChange}
                            />
                        </Col>

                    </Row>
                </div>


                <div style={{ marginBottom: 50 }}>
                    <div className="divider-form" />
                    <ItemForm>
                        <Row>
                            <Col xs={24}>
                                <Button
                                    type="primary"
                                    htmlType="button"
                                    loading={salvando}
                                    onClick={this.onSalvarClick}
                                    className="btn-salvar"
                                >
                                    Salvar
                                </Button>
                            </Col>
                        </Row>
                    </ItemForm>
                </div>


            </div >
        );
    }
}

export default ParametrosNFeForm;



// WEBPACK FOOTER //
// ./src/components/ParametrosNFeForm.js